import { post,get } from "../ajax";

interface saveMerchantType{
  id: number,
  name: string,
}
export async function merchantList(body:Record<string, any>){
    const url = `/api/Merchant/GetMerchantPagelist?Name=${body.Name}&PageIndex=${body.PageIndex}&PageSize=${body.PageSize}`
    const res = await get(url)
    return res;
}

export async function saveMerchant(body:saveMerchantType){
    const url = `/api/Merchant/SaveMerchant`
    const res = await post(url,body)
    return res;
}

export async function unrelatedMerchantList(body:{Name:string,PageIndex:number,PageSize:number,AccountId:number}){
  const url = `/api/Merchant/GetUnrelatedMerchantPagelist?Name=${body.Name}&PageIndex=${body.PageIndex}&PageSize=${body.PageSize}&AccountId=${body.AccountId}`
  const res = await get(url)
  return res;
}

